import { render, staticRenderFns } from "./dcDataStatistics.vue?vue&type=template&id=54b0e7b6&scoped=true"
import script from "./dcDataStatistics.vue?vue&type=script&lang=js"
export * from "./dcDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./dcDataStatistics.vue?vue&type=style&index=0&id=54b0e7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0e7b6",
  null
  
)

export default component.exports